import React, { 
  useRef,
  useState, 
  useEffect 
} from 'react';
import { motion, useAnimationControls } from "framer-motion"

import {
  Segment,
} from 'semantic-ui-react';

export default function ContentAnimatedScroller(props) {
  //console.debug('ContentAnimatedScroller - props', props);

  const controls = useAnimationControls();

  const {
    items,
    isPlaying,
  } = props;

  const direction = 'vertical-reversed'; // horizontal, horizontal-reversed, vertical, vertical-reversed

  //process items to fill screen area and setup for Loop animation
  const outerRef = useRef(null);
  const itemRef = useRef(null);
  const defaults = {
    itemWidth: 160,
    itemHeight: 160,
    itemGap: 25,
    itemCount: items.length,
  }
  const [scrollingItemsState, setScrollingItemsState] = useState([...items]);
  const [scrollingConfigState, setScrollingConfigState] = useState({
    complete: false,
    itemWidth: defaults.itemWidth,
    itemHeight: defaults.itemHeight,
    itemCount: defaults.itemCount,
    calcDiffMinItemsNumber: 0,
    itemsCalc: direction === 'horizontal' ? [0, -(defaults.itemWidth + defaults.itemGap) * defaults.itemCount] : direction === 'horizontal-reversed' ? [-(defaults.itemWidth + defaults.itemGap) * defaults.itemCount, 0] : direction === 'vertical' ? [0, -(defaults.itemHeight + defaults.itemGap) * defaults.itemCount] : direction === 'vertical-reversed' ? [-(defaults.itemHeight + defaults.itemGap) * defaults.itemCount, 0] : null, 
    duration: defaults.itemCount + 25,
  });
  useEffect(() => {
    const scrollerInit = () => {
      if (scrollingConfigState.complete === false) {
        let refsCalc = {
          outer: {
            width: null,
            height: null,
          },
          items: {
            width: null,
            height: null,
          }
        }
        let calcDiffMinItemsNumber;
        let calcNumItemsToAdd;
        if (direction === 'vertical' || direction === 'vertical-reversed') {
          refsCalc.outer.height = outerRef.current.getBoundingClientRect().height;
          refsCalc.items.height = itemRef.current.getBoundingClientRect().height;
          calcDiffMinItemsNumber = Math.ceil(refsCalc.outer.height / (refsCalc.items.height + 0));
          calcNumItemsToAdd = calcDiffMinItemsNumber - scrollingItemsState.length;
        } else {
          refsCalc.outer.width = outerRef.current.getBoundingClientRect().width;
          refsCalc.items.width = itemRef.current.getBoundingClientRect().width;
          calcDiffMinItemsNumber = Math.ceil(refsCalc.outer.width / refsCalc.items.width);
          calcNumItemsToAdd = calcDiffMinItemsNumber - scrollingItemsState.length;
        }
        if (scrollingItemsState.length < calcDiffMinItemsNumber) {
          //find diff
          calcNumItemsToAdd = calcDiffMinItemsNumber - scrollingItemsState.length;
          //select items to add
          let itemsToAdd = []
          for (const item of scrollingItemsState) {
            if (itemsToAdd.length !== calcNumItemsToAdd) {
              itemsToAdd = [...itemsToAdd, item]
            }
          }
          const filledScrollingItems = [...scrollingItemsState, ...itemsToAdd, ...scrollingItemsState, ...itemsToAdd];
          setScrollingItemsState(filledScrollingItems);
          setScrollingConfigState({
            ...scrollingConfigState,
            complete: true,
            itemWidth: refsCalc.items.width,
            itemHeight: refsCalc.items.height,
            calcDiffMinItemsNumber: calcDiffMinItemsNumber,
            itemCount: filledScrollingItems.length,
          });
        } else {
          const filledScrollingItems = [...scrollingItemsState, ...scrollingItemsState, ];
          setScrollingItemsState(filledScrollingItems);
          setScrollingConfigState({
            ...scrollingConfigState,
            complete: true,
            itemWidth: refsCalc.items.width,
            itemHeight: refsCalc.items.height,
            calcDiffMinItemsNumber: calcDiffMinItemsNumber,
            itemCount: filledScrollingItems.length,
          });
        }
      }
    }
    scrollerInit();
  }, [scrollingItemsState, scrollingConfigState]);
  //console.debug('scrollingItemsState', scrollingItemsState);
  //console.debug('scrollingConfigState', scrollingConfigState);

  useEffect(() => {
    //console.debug('isPlaying', isPlaying);
    if (isPlaying) {
      controls.start(direction === 'vertical' || direction === 'vertical-reversed' ? { y: scrollingConfigState.itemsCalc } : { x: scrollingConfigState.itemsCalc })
    } else {
      controls.stop();
    }
  }, [controls, isPlaying, scrollingConfigState])

  
  return (
    <>
      <div ref={outerRef} className={'site-content-scrolling ' + (direction)}>
        <motion.ul 
          transition={{ duration: scrollingConfigState.duration, ease: 'linear', repeat: Infinity, repeatType: "loop" }}
          initial={direction === 'vertical' || direction === 'vertical-reversed' ? { y: 0 } : { x: 0 }}
          animate={controls}
        >
          {scrollingItemsState.map((item, i) => {
            const itemBackground = 'url("'+ item.src +'") no-repeat';
            return (
              <li key={i} ref={itemRef}>
                <Segment basic>
                  <div className={'image'} style={{ background: itemBackground, }}></div>
                </Segment>
              </li>
            )
          })}
        </motion.ul>
      </div>
    </>
  )
}